// routes
import { PATH } from '../../../routes/paths';
// components
import Iconify from '../../../components/Iconify';

// ----------------------------------------------------------------------

const navConfig = [
  // Overview
  // ----------------------------------------------------------------------
  {
    items: [
      {
        permissions: [],
        title: 'layout.menus.overview',
        path: PATH.overview,
        icon: <Iconify icon={'ic:baseline-dashboard'} />,
      },
    ],
  },

  // Business
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.subscription.root',
    items: [
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.subscription.business',
        path: PATH.subscription.business.root,
        icon: <Iconify icon={'ic:baseline-store'} />,
      },
    ],
  },

  // Distributor
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.distributor.root',
    items: [
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.distributor.distributor',
        path: PATH.distributor.distributor.root,
        icon: <Iconify icon={'ic:baseline-3p'} />,
      },
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.distributor.commission',
        path: PATH.distributor.commission,
        icon: <Iconify icon={'ic:baseline-chat'} />,
      },
    ],
  },

  // Support
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.support.root',
    items: [
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.support.conversations',
        path: PATH.support.root,
        icon: <Iconify icon={'ic:baseline-support-agent'} />,
      },
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.support.settings',
        path: PATH.support.settings,
        icon: <Iconify icon={'ic:baseline-tune'} />,
      },
    ],
  },

  // Explore
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.explore.root',
    items: [
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.explore.overview',
        path: PATH.explore.overview,
        icon: <Iconify icon={'ic:baseline-dashboard'} />,
      },
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.explore.record',
        path: PATH.explore.record.root,
        icon: <Iconify icon={'ic:baseline-category'} />,
      },
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.explore.report',
        path: PATH.explore.report,
        icon: <Iconify icon={'ic:baseline-assessment'} />,
      },
    ],
  },

  // Project
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.project.root',
    items: [
      {
        permissions: [
          'web.project.project.management.view',
          'web.project.project.management.create',
          'web.project.project.management.edit',
          'web.project.project.management.delete',
        ],
        title: 'layout.menus.project.board',
        path: PATH.project.root,
        icon: <Iconify icon={'ic:outline-developer-board'} />,
      },
    ],
  },

  // Management
  // ----------------------------------------------------------------------
  {
    subheader: 'layout.menus.management.root',
    items: [
      {
        permissions: [],
        title: 'layout.menus.management.settings',
        path: PATH.management.settings.root,
        icon: <Iconify icon={'ic:baseline-settings'} />,
      },
      {
        permissions: ['admin.user.management'],
        title: 'layout.menus.management.user',
        path: PATH.management.user.root,
        icon: <Iconify icon={'ic:baseline-manage-accounts'} />,
      },
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.management.role',
        path: PATH.management.role.root,
        icon: <Iconify icon={'ic:baseline-military-tech'} />,
      },
      {
        permissions: ['admin.general.settings'],
        title: 'layout.menus.management.tax',
        path: PATH.management.tax.root,
        icon: <Iconify icon={'ic:baseline-paid'} />,
      },
      // {
      //   permissions: ['admin.bundle.management'],
      //   title: 'layout.menus.management.plan',
      //   path: PATH.management.plan.root,
      //   icon: <Iconify icon={'ic:baseline-category'} />,
      // },
      {
        permissions: ['admin.bundle.management'],
        title: 'layout.menus.management.discount',
        path: PATH.management.discount.root,
        icon: <Iconify icon={'ic:baseline-discount'} />,
      },
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.management.categoryExpense',
        path: PATH.management.categoryExpense.root,
        icon: <Iconify icon={'ic:outline-category'} />,
      },
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.management.uom',
        path: PATH.management.uom.root,
        icon: <Iconify icon={'ic:baseline-straighten'} />,
      },
      {
        permissions: ['admin.operations.management'],
        title: 'layout.menus.management.nearpayTerminal',
        path: PATH.management.nearpayTerminal.root,
        icon: <Iconify icon={'ic:outline-paypal'} />,
      },
    ],
  },
];

export default navConfig;
